import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import Header from "../../components/header";

import CardUpDown from "../../components/cardupdown";
import CardLeftRight from "../../components/cardleftright";
import AdPage from "../../components/AdPage";
import { dataListsType } from "../../shared/type";
import { DataLists } from "../../dataLists/DataLists";

import { HelmetSeo } from "../../components/HelmetSeo";

export default function MorePage() {
  // const { state } = useLocation();
  // const dataProps = state?.dataProps || [];

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  let category = decodeURIComponent(params.get("category") || "");
  let nation = decodeURIComponent(params.get("nation") || "");
  const label = decodeURIComponent(params.get("label") || "");

  const [dataProps, setdataProps] = useState<dataListsType[]>([]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getAllData = useCallback(() => {
    if (!category || !nation) return null;
    const data = [...DataLists];
    const allData = data.filter(
      (item) => item.category === category && item.nation === nation
    );
    setdataProps(allData);
  }, [category, nation, setdataProps]);

  useEffect(() => {
    getAllData();
  }, [category, getAllData, nation]);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const title = label
    ? `${label} | ${nation} ${category} | Explore Asia`
    : "Explore Asia";

  const description = label
    ? `Browse ${category} guides and experiences in ${nation}. ${label} collection on Explore Asia.`
    : "Explore Asia collections.";

  return (
    <>
      {/* <HelmetSeo
        title={
          label
            ? `${label} | ${nation} ${category} | Explore Asia`
            : "Explore Asia"
        }
        description={
          label
            ? `Browse ${category} content in ${nation}. ${label} collection on Explore Asia.`
            : "Explore Asia collections."
        }
        ogType="website"
      /> */}
      <HelmetSeo title={title} description={description} ogType="website" />
      <Header />

      <AdPage />
      <div className="w-full h-full fixed top-0 left-0 -z-10 bg-white/60 bg-blend-overlay backdrop-blur-md"></div>

      <div className="w-full flex justify-center">
        <div className="flex flex-col justify-center 2xl:max-w-[1500px] max-w-[1200px] my-8">
          <div className="w-full flex items-center gap-x-2 px-8 pb-6">
            <img
              src="icon/back.png"
              alt="back"
              onClick={() => window.history.back()}
              className="w-6 h-6 md:w-8 md:h-8 mr-3 flex-shrink-0 cursor-pointer"
            />
            <h1 className="md:text-3xl text-2xl font-extrabold">{label}</h1>
          </div>
          <div className="w-full mb-16 px-8">
            <div className="w-full flex flex-col gap-y-10 mt-2 px-2">
              {windowWidth > 800 ? (
                <CardLeftRight
                  props={dataProps.sort(() => Math.random() - 0.5).slice(0)}
                />
              ) : (
                <CardUpDown
                  props={dataProps.sort(() => Math.random() - 0.5).slice(0)}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
